import { ACTION_TYPES, useRepassesSetoriaisDispatch, useRepassesSetoriaisState } from "./repasses-setoriais-context";
import MunicipalPortalAAppService from "application/platform/municipal-portal-service";
import { IRepasseSetorialPagedRequest } from "models/request/repasse-setorial-paged-request";
import { downloadFile } from "utils/download-file";

export const useRepassesSetoriaisController = () => {
    const dispatch = useRepassesSetoriaisDispatch();
    const { repassePagedRequest } = useRepassesSetoriaisState();

    async function exportRepasses(format: string) {
        const file = await MunicipalPortalAAppService.exportRepassesSetoriais(repassePagedRequest, format);
        downloadFile(file);
    }

    async function onInit() {
        let request = { page: 0, pageSize: 10 } as IRepasseSetorialPagedRequest;

        dispatch({ type: ACTION_TYPES.setRepassePagedRequest, payload: request });
        dispatch({ type: ACTION_TYPES.setLoading, payload: true });

        await listRepasses(request);
        await loadLookups();

        dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }

    async function loadLookups() {
        try {
            const [areas, origens, ultimaAtualizacao] = await Promise.all([
                MunicipalPortalAAppService.listAreasTransparenciaSetorial(),
                MunicipalPortalAAppService.listOrigensRepasseSetorial(),
                MunicipalPortalAAppService.getRepassesSetoriaisUltimaAtualizacao()
            ]);
            dispatch({ type: ACTION_TYPES.setAreas, payload: areas });
            dispatch({ type: ACTION_TYPES.setOrigens, payload: origens });
            dispatch({ type: ACTION_TYPES.setUltimaAtualizacao, payload: ultimaAtualizacao?.dtaUltimaAtualizacao ?? null });
        } catch (error) {
            console.log(error);
        }
    }

    async function listRepasses(request: IRepasseSetorialPagedRequest, showLoading: boolean = false) {
        try {
            if (showLoading) {
                dispatch({ type: ACTION_TYPES.setLoading, payload: true });
            }
            dispatch({ type: ACTION_TYPES.setError, payload: null });

            const [repasses, totais] = await Promise.all([
                MunicipalPortalAAppService.listRepassesSetoriais(request),
                MunicipalPortalAAppService.getRepassesSetoriaisTotais({
                    term: request.term,
                    idAreaTransparenciaSetorial: request.idAreaTransparenciaSetorial,
                    idOrigemRepasseSetorial: request.idOrigemRepasseSetorial,
                    ano: request.ano,
                }),
            ]);

            dispatch({ type: ACTION_TYPES.setRepasses, payload: repasses });
            dispatch({ type: ACTION_TYPES.setTotais, payload: totais });
        } catch (error) {
            console.log(error);
            dispatch({ type: ACTION_TYPES.setError, payload: 'Não foi possível carregar os repasses setoriais. Tente novamente mais tarde.' });
        } finally {
            if (showLoading) {
                dispatch({ type: ACTION_TYPES.setLoading, payload: false });
            }
        }
    }

    const handleOnChange = (e: any) => {
        let updated = { ...repassePagedRequest };

        if (e.target.name === "text-field-term") {
            updated.term = e.target.value;
            if (!updated.term) {
                (async () => await listRepasses({ ...updated, page: 0 }, true))();
            }
        } else if (e.target.name === "select-area-id") {
            updated.idAreaTransparenciaSetorial = e.target.value;
        } else if (e.target.name === "select-origem-id") {
            updated.idOrigemRepasseSetorial = e.target.value;
        } else if (e.target.name === "text-field-ano") {
            updated.ano = e.target.value ? Number(e.target.value) : undefined;
        } else if (e.target.name === "select-order-direction") {
            updated.orderDirection = e.target.value;
            (async () => await listRepasses({ ...updated, page: 0 }, true))();
        }

        dispatch({ type: ACTION_TYPES.setRepassePagedRequest, payload: updated });
    };

    return { listRepasses, handleOnChange, onInit, exportRepasses };
}
